import { createSelector } from '@reduxjs/toolkit';

import { EnvQuestionValue } from '@/domain/impact-env/entities/question.entity.ts';
import { RootState } from '@/domain/store';

export const selectImpactEnvQuestions = (state: RootState) => {
  return state.impactEnv.questions;
};

export const selectImpactEnvResponses = (state: RootState) => {
  return state.impactEnv.responses;
};

export const selectEnvDebugMode = (state: RootState) => {
  return state.impactEnv.debugMode;
};

export const selectImpactEnvAnswersMap = createSelector(
  [selectImpactEnvResponses],
  (impactEnvResponses) => {
    const impactEnvResponsesMap: Map<string, EnvQuestionValue> = new Map();
    for (const envResponse of impactEnvResponses) {
      impactEnvResponsesMap.set(envResponse.paramId, envResponse);
    }
    return impactEnvResponsesMap;
  },
);
